import { Link } from "react-router-dom";
import { Phone, ArrowRight, ShieldCheck, Star } from "lucide-react";
import { COMPANY, IMAGES } from "../data/site";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative bg-stone-900 text-white overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          srcSet={`${IMAGES.hero.replace('w=1900', 'w=640')} 640w, ${IMAGES.hero.replace('w=1900', 'w=1200')} 1200w, ${IMAGES.hero} 1900w`}
          sizes="100vw"
          alt="Modern Austin concrete driveway and home"
          width="1900"
          height="1069"
          className="w-full h-full object-cover"
          loading="eager"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-950/85 via-stone-950/65 to-stone-950/35" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-32 lg:pt-40 pb-24 lg:pb-36">
        <div className="max-w-3xl">
          <div
            className="inline-flex items-center gap-2 px-3 py-1.5 bg-red-600 text-white text-[10px] uppercase tracking-[0.22em] font-bold mb-7"
            data-testid="hero-badge"
          >
            <Star size={12} fill="#fff" /> Austin, TX · Bonded &amp; Insured
          </div>

          <h1 className="font-impact font-black uppercase text-5xl sm:text-6xl lg:text-[6.5rem] tracking-tight leading-[0.88]">
            Pour it Strong.
            <br />
            <span className="text-red-500">Plant it Smart.</span>
          </h1>

          <p className="mt-7 text-lg sm:text-xl text-stone-200 max-w-2xl leading-relaxed">
            Texan Strong Builds is Austin, TX's contractor for <strong className="text-white">concrete that holds</strong> and{" "}
            <strong className="text-white">landscapes that thrive</strong>. Driveways, stamped patios,
            foundations, retaining walls — and drought-tough <span className="text-white font-semibold">xeriscape</span> yards
            built for the Hill Country sun.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <Link to="/contact" data-testid="hero-cta-estimate" className="btn-primary">
              Get a Free Estimate <ArrowRight size={18} />
            </Link>
            <a href={COMPANY.phoneTel} data-testid="hero-cta-call" className="btn-ghost-dark">
              <Phone size={18} /> Call {COMPANY.phone}
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-7 gap-y-3 text-sm text-stone-300">
            <span className="flex items-center gap-2">
              <ShieldCheck size={16} className="text-red-500" /> Bonded &amp; insured in Texas
            </span>
            <span className="flex items-center gap-2">
              <Star size={16} className="text-yellow-400" fill="#facc15" /> 5-star Google reviews
            </span>
            <span>10+ years building Austin</span>
          </div>
        </div>
      </div>

      {/* Bottom trust strip */}
      <div className="relative border-t border-white/10 bg-stone-950/75 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-4 flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-[11px] uppercase tracking-[0.22em] text-white font-semibold">
          <span>Concrete Patios</span>
          <span className="text-stone-500">·</span>
          <span>Stamped Concrete</span>
          <span className="text-stone-500">·</span>
          <span>Driveways</span>
          <span className="text-stone-500">·</span>
          <span>Foundations</span>
          <span className="text-stone-500">·</span>
          <span className="text-red-500">Xeriscape</span>
          <span className="text-stone-500">·</span>
          <span>Concrete Repair</span>
        </div>
      </div>
    </section>
  );
}
